import { ChevronDown } from 'lucide-react';
import { useState } from 'react';

const TableRow = ({ isHeader = false, data }) => {
  return (
    <div className={`flex w-full gap-1 ${!isHeader ? 'mb-0' : ''}`}>
      {data.map((item, index) => {
        let commonClasses = 'md:h-[48px] h-[30px] tracking-wide font-bold flex items-center mb-1 px-[4px] md:px-2 text-[4px] md:text-[12px]';
        let widthClass = '';
        let bgColor = isHeader
          ? 'bg-[#03897B] text-white'
          : 'bg-[#F3F5F5] text-black font-bold border-b-[2px] border-[#9FAFAF]';
        let customColor =
          (index === 8 || index === 9) && !isHeader
            ? 'bg-[#F38323] border-b-[2px] font-bold border-[#9FAFAF] text-white'
            : bgColor;

        switch (index) {
          case 0:
            widthClass = 'w-[130px]';
            break;
          case 1:
            widthClass = 'w-[134px]';
            break;
          case 2:
            widthClass = 'w-[130px]';
            break;
          case 3:
            widthClass = 'w-[94px]';
            break;
          case 4:
            widthClass = 'w-[120px]';
            break;
          case 5:
            widthClass = 'w-[71px]';
            break;
          case 6:
            widthClass = 'w-[130px]';
            break;
          case 7:
            widthClass = 'w-[131px]';
            break;
          case 8:
          case 9:
            widthClass = 'w-[131px]';
            break;
          default:
            widthClass = 'w-[100px]';
        }

        const extraBold = index === 0 && !isHeader ? 'font-extrabold text-black' : '';

        return (
          <div
            key={index}
            className={`${widthClass} ${commonClasses} ${customColor} ${extraBold} rounded-[5px]`}
          >
            {item}
          </div>
        );
      })}
    </div>
  );
};

const TableComponent = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [selectedAbattoir, setSelectedAbattoir] = useState("Abattoir 1");

  const tableHeaders = [
    'GROWER NAME', 'COMPANY REGISTRATION', 'FARM NAME', 'FARM ERF NO',
    'FARM COORDINATES', 'SIZE HA', 'MUNICIPALITY', 'PROVINCE',
    'EIA COMMENT', 'EIA COSTING'
  ];

  const tableData = new Array(8).fill([
    'Sipo James', '2023/1333/56/', 'Farm 1', 'F123', 'XXXXX', '3 Ha',
    'Mun1', 'Gauteng', 'Approved', 'R1234'
  ]);

  const abattoirs = ["Abattoir 1", "Abattoir 2", "Abattoir 3"];

  return (
    <div className="relative w-full md:mt-12  mt-5">
  
     

      {/* Table Header */}
      <div className="mt-6">
        <TableRow isHeader={true} data={tableHeaders} />

        {/* Table Rows */}
        {tableData.map((row, idx) => (
          <TableRow key={idx} data={row} />
        ))}

        {/* Footer Info */}
        <div className='flex justify-end md:px-11'>
          <div className="mt-1 md:text-sm text-[5px] md:leading-6 text-black">
            <p>EIA Assessor: <strong>Sibusaki Khumalo</strong></p>
            <p>Registration Number: <strong>EAI2345</strong></p>
            <p>Mobile: <strong>076985400X</strong></p>
            <p>Email: <strong>eim@environment.com</strong></p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TableComponent;
